import * as React from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

export default function ReportSource(props) {
  const rows = props.rows;
  const columns = props.columns;
  return (
    <div
      style={{
        height: "90vh",
        width: "100vw",
        overflow: "scroll",
      }}
      className="ag-theme-alpine"
    >
      <AgGridReact
        defaultColDef={{
          sortable: true,
          filter: true,
        }}
        rowData={rows}
      >
        {columns?.map((column) => {
          return <AgGridColumn field={column} filter="agTextColumnFilter" />;
        })}
      </AgGridReact>
    </div>
  );
}
